import {
  generalCategoryGroupLabelToName,
  generalCategoryGroupNames,
  productReviewCategoryGroupLabelToName,
  productReviewCategoryGroupNames,
} from 'config/filters'
import { Location, Schema } from 'typings/filters'
import { useMemo } from 'react'

type FilterGroupNames = typeof generalCategoryGroupNames | typeof productReviewCategoryGroupNames
type FilterGroupLabels =
  | typeof generalCategoryGroupLabelToName
  | typeof productReviewCategoryGroupLabelToName

const keywordsToExclude = ['Product Sub Group 1', 'Product Sub Group 2', 'Product Sub Group 3']
export const useFilterSchema = (): {
  filterSchema: Schema
  filterGroupNames: FilterGroupNames
  filterGroupLabels: FilterGroupLabels
  invalidFilterGroupNames: FilterGroupNames
  invalidFilterSubGroupNames: string[] | string
} => {
  const { pathname } = window.location
  const filterSchema = useMemo(
    () => (pathname === Location.PRODUCT_REVIEW ? Schema.CIE_REVIEW : Schema.CIE),
    [pathname]
  )

  const filterGroupNames = useMemo(
    () =>
      filterSchema === Schema.CIE ? generalCategoryGroupNames : productReviewCategoryGroupNames,
    [filterSchema]
  )

  const filterGroupLabels = useMemo(
    () =>
      filterSchema === Schema.CIE
        ? generalCategoryGroupLabelToName
        : productReviewCategoryGroupLabelToName,
    [filterSchema]
  )

  const invalidFilterGroupNames = useMemo(
    () =>
      filterSchema === Schema.CIE ? productReviewCategoryGroupNames : generalCategoryGroupNames,
    [filterSchema]
  )

  const invalidFilterSubGroupNames = useMemo(
    () => (pathname === Location.PRODUCT_REVIEW ? keywordsToExclude : ''),
    [pathname]
  )

  return {
    filterSchema,
    filterGroupNames,
    filterGroupLabels,
    invalidFilterGroupNames,
    invalidFilterSubGroupNames,
  }
}
